import { PreloadingStrategy, Route } from '@angular/router';
import { Observable, of } from 'rxjs';

export class FSABPreloadingStrategy implements PreloadingStrategy {
  preload(route: Route, load: Function): Observable<boolean> {
    return route.data && route.data.preload ? load() : of(null);
  }
}
